import { post, get } from '../util/crmAxios';
const devHost = 'http://192.168.30.254:8080/api/';
const congDevHost = 'http://192.168.30.10:8080/api/';
import { getBasicUrls } from '../util/config';
const schoolCrm = getBasicUrls().schoolCrm;

export const applyList = params =>
	post(schoolCrm + 'manage/agentChannel/applyList', params);

export const viewProtocol = params =>
	post(schoolCrm + 'manage/agentChannel/viewProtocol', params);

export const detailInfo = params =>
	post(schoolCrm + 'manage/agentChannel/detailInfo', params);

export const getList = params =>
	post(schoolCrm + 'manage/agentFirstProtocolReward/getList', params);

export const getListCustom = params =>
	post(schoolCrm + 'manage/needBearRewardForCustomer/getList', params);

export const queryIntroduceApplyDetail = params =>
	post(schoolCrm + 'agent/introduce/apply/queryIntroduceApplyDetail', params);

export const queryIntroduceAgentList = params =>
	post(schoolCrm + 'agent/introduce/apply/queryIntroduceAgentList', params);
// 【转介绍】转介绍业绩管理-分页查询(增加转介绍客户id列表接口)
export const queryIntroduceCustomPage = params =>
	post(schoolCrm + 'agent/introduce/apply/queryIntroduceCustomPage', params);

// 转介绍业绩管理-有效可用额度合计查询（增加入参）
export const queryIntroduceCustomEffective = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryIntroduceCustomEffective',
		params
	);
// 转介绍业绩管理-升级申请查询当前级别
export const queryIntroduceCustomEffectiveApply = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryIntroduceCustomEffectiveApply',
		params
	);

// 转介绍业绩管理-升级申请（修改实时查额度）
export const introduceCustomApply = params =>
	post(schoolCrm + 'agent/introduce/apply/introduceCustomApply', params);

// 【转介绍】转介绍客户申请-分页查询
export const queryIntroduceApplyPage = params =>
	post(schoolCrm + 'agent/introduce/apply/queryIntroduceApplyPage', params);

// 业绩额度使用记录-分页查询
export const queryIntroduceCustomUsedRecordPage = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryIntroduceCustomUsedRecordPage',
		params
	);

// 转介绍业绩管理-转介绍id下拉
export const queryIntroduceCustomIdResDto = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryIntroduceCustomIdResDto',
		params
	);

export const queryRegionIntroduceCustomPage = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryRegionIntroduceCustomPage',
		params
	);

export const queryRegionSubCampusListV2 = params =>
	get(schoolCrm + 'manage/transfer/order/queryRegionSubCampusListV2', params);

export const queryAgentRewardReturnPage = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryAgentRewardReturnPage',
		params
	);

export const queryAgentServiceSharePage = params =>
	post(
		schoolCrm + 'agent/introduce/apply/queryAgentServiceSharePage',
		params
	);
